/* IBO custom (see theme/CUSTOMIZATIONS.md), 2026-09-25. Phones (< 768 px), cart drawer only.
   Shopify shows the express checkout buttons (Shop Pay, Apple Pay, Google Pay, PayPal...) in one
   row when they fit (each needs about 110 px). When there are more than fit (for example 4 on an
   iPhone), Shopify stacks them one per row, which pushed the cart items out of view.
   In that case this keeps only the first row visible and adds a "More options" button beside it;
   tapping it shows every button. The wallet buttons themselves are never restyled; the visible
   one keeps its full size. Styles: assets/ibo.css ("Cart drawer: compact footer"). */
(() => {
  const d = document;
  const me = d.currentScript;
  const TXT = { more: (me && me.dataset.more) || 'More options', less: (me && me.dataset.less) || 'Fewer options' };
  const mq = window.matchMedia('(max-width: 767px)');
  const SLOT = 110; // Shopify: min 100 px per button in a row + 10 px spacing
  const chevron = '<svg class="ibo-express-more__icon" width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  let uid = 0;

  const wallets = (ac) => [...ac.children].filter((c) => c.tagName.includes('-') && getComputedStyle(c).display !== 'none').length;

  const setLabel = (wrap, btn) => {
    const open = wrap.classList.contains('is-open');
    const label = open ? TXT.less : TXT.more;
    if (btn.dataset.label !== label) {
      btn.dataset.label = label;
      btn.innerHTML = `<span>${label}</span>${chevron}`;
    }
    if (btn.getAttribute('aria-expanded') !== String(open)) btn.setAttribute('aria-expanded', String(open));
  };

  const update = (wrap) => {
    const ac = wrap.querySelector('shopify-accelerated-checkout-cart');
    if (!ac) return;
    const content = ac.closest('.dynamic-checkout__content') || ac.parentElement;
    const n = wallets(ac);
    const rowH = parseFloat(getComputedStyle(ac).getPropertyValue('--shopify-accelerated-checkout-button-inline-size')) || 42;
    let stacked = n >= 2 && (n >= 6 || wrap.clientWidth <= SLOT * n - 10);
    if (!stacked && !wrap.classList.contains('ibo-express--collapsible') && ac.offsetHeight > rowH * 1.6) stacked = true;
    const collapsible = mq.matches && stacked;

    let btn = wrap.querySelector(':scope > .ibo-express-more');
    if (collapsible && !btn) {
      if (!content.id) content.id = `ibo-express-${++uid}`;
      btn = d.createElement('button');
      btn.type = 'button';
      btn.className = 'ibo-express-more';
      btn.setAttribute('aria-controls', content.id);
      btn.addEventListener('click', () => {
        wrap.classList.toggle('is-open');
        setLabel(wrap, btn);
      });
      wrap.appendChild(btn);
    }
    if (wrap.classList.contains('ibo-express--collapsible') !== collapsible) wrap.classList.toggle('ibo-express--collapsible', collapsible);
    if (!collapsible && wrap.classList.contains('is-open')) wrap.classList.remove('is-open');
    if (btn) {
      if (btn.hidden === collapsible) btn.hidden = !collapsible;
      setLabel(wrap, btn);
    }
    // Offset of the first button inside the stack (Shopify may add a top margin), so the
    // one visible button lines up with "More options" and is never cut.
    const first = [...ac.children].find((c) => c.tagName.includes('-') && c.getBoundingClientRect().height > 0);
    if (collapsible && first) {
      const off = `${Math.max(0, Math.round(first.getBoundingClientRect().top - content.getBoundingClientRect().top))}px`;
      if (content.style.getPropertyValue('--ibo-x-off') !== off) content.style.setProperty('--ibo-x-off', off);
    }
  };

  // 2026-09-25 fix: requestAnimationFrame never fires while the tab is hidden (background or
  // prerendered tab, some preview/test panes), and the old code only updated inside it, so the
  // toggle never appeared there and stayed stuck until a frame ran. Now a timer fallback runs
  // the update too; whichever comes first wins.
  let queued = false;
  let raf = 0;
  let tmr = 0;
  const flush = () => {
    if (!queued) return;
    queued = false;
    cancelAnimationFrame(raf);
    clearTimeout(tmr);
    d.querySelectorAll('#cart-drawer .dynamic-cart-btns').forEach(update);
  };
  const scan = () => {
    if (queued) return;
    queued = true;
    raf = requestAnimationFrame(flush);
    tmr = setTimeout(flush, 120);
  };

  const start = () => {
    const drawer = d.getElementById('cart-drawer');
    if (!drawer) return;
    new MutationObserver(scan).observe(drawer, { childList: true, subtree: true });
    if (mq.addEventListener) mq.addEventListener('change', scan);
    window.addEventListener('resize', scan);
    d.addEventListener('on:cart-drawer:after-open', scan);
    d.addEventListener('visibilitychange', scan);
    scan();
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})();
